import { issueSyncHandler } from './IssueSyncHandler';
import { operatingDataSyncHandler } from './OperatingDataSyncHandler';
import { periodicCheckSyncHandler } from './PeriodicCheckSyncHandler';
import { SyncTypeHandler } from './types';

export const syncTypeHandlers: SyncTypeHandler[] = [
  issueSyncHandler,
  operatingDataSyncHandler,
  periodicCheckSyncHandler,
];

export function getSyncHandler(typeOfData: string): SyncTypeHandler | undefined {
  return syncTypeHandlers.find((handler) => handler.syncType === typeOfData);
}

export * from './types';
export { IssueSyncHandler, issueSyncHandler } from './IssueSyncHandler';
export { OperatingDataSyncHandler, operatingDataSyncHandler } from './OperatingDataSyncHandler';
export { PeriodicCheckSyncHandler, periodicCheckSyncHandler } from './PeriodicCheckSyncHandler';
